export default __webpack_public_path__ + "static/media/08_petCtMriTracker.ab370816.png";